import { render, staticRenderFns } from "./NotificationTimelineEventItem.vue?vue&type=template&id=859357e0&scoped=true&"
import script from "./NotificationTimelineEventItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationTimelineEventItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859357e0",
  null
  
)

export default component.exports